import React, { useRef, useState } from "react";
import { useLanguage } from "../../i18n";

// A single "+" tile opens a sheet asking Camera vs Files, instead of two
// separate tiles taking up grid space. `capture="environment"` opens the
// device camera directly on mobile; the plain input opens the file/gallery
// picker. On desktop, browsers without camera support just fall back to a
// normal file picker for both, so neither option breaks there.
export function PhotoPickerButtons({ busy, onFiles }: { busy: boolean; onFiles: (files: FileList | null) => void }) {
  const cameraInput = useRef<HTMLInputElement>(null);
  const uploadInput = useRef<HTMLInputElement>(null);
  const [showSheet, setShowSheet] = useState(false);
  const { t } = useLanguage();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onFiles(e.target.files);
    e.target.value = "";
  }

  return (
    <>
      <button type="button" className="photo-add-btn" disabled={busy} onClick={() => setShowSheet(true)}>
        <span>{busy ? "…" : "+"}</span>
      </button>

      {showSheet && (
        <>
          <div className="filter-backdrop" onClick={() => setShowSheet(false)} />
          <div className="filter-sheet" style={{ paddingBottom: 20 }}>
            <div className="filter-sheet-handle" />
            <div className="filter-sheet-title" style={{ marginBottom: 10 }}>{t("photoPickerButtons.addPhotoTitle")}</div>
            <div className="menu-group" style={{ marginTop: 0 }}>
              <div
                className="menu-item"
                onClick={() => {
                  setShowSheet(false);
                  cameraInput.current?.click();
                }}
              >
                {t("photoPickerButtons.takePhoto")}
              </div>
              <div
                className="menu-item"
                onClick={() => {
                  setShowSheet(false);
                  uploadInput.current?.click();
                }}
              >
                {t("photoPickerButtons.chooseFromFiles")}
              </div>
            </div>
            <button className="btn-outline btn-sm" style={{ marginTop: 12 }} onClick={() => setShowSheet(false)}>
              {t("common.cancel")}
            </button>
          </div>
        </>
      )}

      <input
        ref={cameraInput}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={handleChange}
      />
      <input
        ref={uploadInput}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </>
  );
}
